var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_296_374)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_296_374)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.42857V7.46667H0V0Z",
    fill: "#1A47B8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42857 0V1.06667H22V0H9.42857ZM9.42857 2.13333V3.2H22V2.13333H9.42857ZM9.42857 4.26667V5.33333H22V4.26667H9.42857ZM9.42857 6.4V7.46667H22V6.4H9.42857ZM0 8.53333V9.6H22V8.53333H0ZM0 10.6667V11.7333H22V10.6667H0ZM0 12.8V13.8667H22V12.8H0ZM0 14.9333V16H22V14.9333H0Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04761 1.06641V2.13307H2.09523V1.06641H1.04761ZM3.14285 1.06641V2.13307H4.19046V1.06641H3.14285ZM5.23808 1.06641V2.13307H6.2857V1.06641H5.23808ZM7.33332 1.06641V2.13307H8.38094V1.06641H7.33332ZM6.2857 2.13307V3.19974H7.33332V2.13307H6.2857ZM4.19046 2.13307V3.19974H5.23808V2.13307H4.19046ZM2.09523 2.13307V3.19974H3.14285V2.13307H2.09523ZM1.04761 3.19974V4.26641H2.09523V3.19974H1.04761ZM3.14285 3.19974V4.26641H4.19046V3.19974H3.14285ZM5.23808 3.19974V4.26641H6.2857V3.19974H5.23808ZM7.33332 3.19974V4.26641H8.38094V3.19974H7.33332ZM1.04761 5.33307V6.39974H2.09523V5.33307H1.04761ZM3.14285 5.33307V6.39974H4.19046V5.33307H3.14285ZM5.23808 5.33307V6.39974H6.2857V5.33307H5.23808ZM7.33332 5.33307V6.39974H8.38094V5.33307H7.33332ZM6.2857 4.26641V5.33307H7.33332V4.26641H6.2857ZM4.19046 4.26641V5.33307H5.23808V4.26641H4.19046ZM2.09523 4.26641V5.33307H3.14285V4.26641H2.09523Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_296_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_296_374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.38216564cb7a4599b6b2710d3dddbbb4.svg";
export { ForwardRef as ReactComponent };